<div class="scroll-container">
    <h1 ghs-label="tools.keyboard"></h1>

    <p ghs-label="tools.keyboard.global"></p>


    <div class="line" ghs-setting-menu="keyboardShortcuts"></div>

    <ul>
        <li>
            <kbd><span ghs-label="tools.keyboard.ctrl"></span></kbd> + <kbd><span>z</span></kbd> <span
                ghs-label="tools.keyboard.undo"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.ctrl"></span></kbd> +
            <kbd><span>y</span></kbd>&nbsp;|&nbsp;<kbd><span ghs-label="tools.keyboard.ctrl"></span></kbd> +
            <kbd><span ghs-label="tools.keyboard.shift"></span></kbd> + <kbd><span>Z</span></kbd>
            <span ghs-label="tools.keyboard.redo"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.esc"></span></kbd> <span ghs-label="tools.keyboard.mainMenu"></span>
        </li>
        <li>
            <kbd><span>↑</span></kbd>&nbsp;|&nbsp;<kbd><span>+</span></kbd> <span
                ghs-label="tools.keyboard.zoomIn"></span>
        </li>
        <li>
            <kbd><span>↓</span></kbd>&nbsp;|&nbsp;<kbd><span>-</span></kbd> <span
                ghs-label="tools.keyboard.zoomOut"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.ctrl"></span></kbd> + <kbd><span>r</span></kbd> <span
                ghs-label="tools.keyboard.zoomReset"></span>
        </li>
        <li>
            <kbd><span>f</span></kbd> <span ghs-label="tools.keyboard.toggleFullscreen"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.tab"></span></kbd> <span ghs-label="tools.keyboard.toggelTab"></span>
        </li>
        <li>
            <kbd><span>n</span></kbd> <span ghs-label="tools.keyboard.round"></span>
        </li>
        <li>
            <kbd><span>m</span></kbd> <span ghs-label="tools.keyboard.am"></span>
        </li>
        <li>
            <kbd><span>a</span></kbd> <span ghs-label="tools.keyboard.amAdvantage"></span>
        </li>
        <li>
            <kbd><span>d</span></kbd> <span ghs-label="tools.keyboard.amDisadvantage"></span>
        </li>
        <li>
            <kbd><span>l</span></kbd> <span ghs-label="tools.keyboard.loot"></span>&nbsp;|&nbsp;<span
                ghs-label="tools.keyboard.activeCharacter.lootInc"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.shift"></span></kbd>&nbsp;+&nbsp;<kbd><span>X</span></kbd> <span
                ghs-label="tools.keyboard.activeCharacter.lootDec"></span>
        </li>
        <li>
            <kbd><span>1</span></kbd>-<kbd><span>6</span></kbd> <span ghs-label="tools.keyboard.toggleElements"></span>
        </li>
        <li>
            <kbd><span>h</span></kbd> <span ghs-label="tools.keyboard.toggleAbsent"></span>
        </li>
        <li>
            <kbd><span>s</span></kbd> <span
                ghs-label="tools.keyboard.select"></span>&nbsp;(<kbd><span>0</span></kbd>-<kbd><span>9</span></kbd>)
        </li>
        <li>
            <kbd><span>w</span></kbd> <span
                ghs-label="tools.keyboard.selectNatural"></span>&nbsp;(<kbd><span>0</span></kbd>-<kbd><span>9</span></kbd>)
        </li>
        <li>
            <kbd><span>x</span></kbd> <span ghs-label="tools.keyboard.difficulty"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.alt"></span></kbd>&nbsp;+&nbsp;<kbd><span>x</span></kbd> <span
                ghs-label="tools.keyboard.activeCharacter.xpInc"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.shift"></span></kbd>&nbsp;+&nbsp;<kbd><span>X</span></kbd> <span
                ghs-label="tools.keyboard.activeCharacter.xpDec"></span>
        </li>
        <li>
            <kbd><span>e</span></kbd> <span ghs-label="tools.keyboard.events"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.shift"></span></kbd> + <kbd><span>f</span></kbd> <span ghs-label="tools.keyboard.finish"></span>
        </li>
        <li>
            <kbd><span>p</span></kbd> <span ghs-label="tools.keyboard.party"></span>
        </li>
        <li>
            <kbd><span>g</span></kbd> <span ghs-label="tools.keyboard.globalMap"></span>
        </li>
        <li>
            <kbd><span>c</span></kbd> <span ghs-label="tools.keyboard.scenarioChart"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.shift"></span></kbd>&nbsp;+&nbsp;<kbd><span>H</span></kbd> <span
                ghs-label="tools.keyboard.toggleHandSize"></span>
        </li>
        <li>
            <kbd><span>t</span></kbd> <span ghs-label="tools.keyboard.toggleTraits"></span>
        </li>
        <li>
            <kbd><span>i</span></kbd> <span ghs-label="tools.keyboard.toggleDamageHP"></span>
        </li>
        <li>
            <kbd><span>#</span></kbd> <span ghs-label="tools.keyboard.togglePlayerNumber"></span>
        </li>
        <li>
            <kbd><span>?</span></kbd> <span ghs-label="tools.keyboard.keyboard"></span>
        </li>
    </ul>

    <p ghs-label="tools.keyboard.entityMenu"></p>
    <ul>
        <li>
            <kbd><span>→</span></kbd> <span ghs-label="tools.keyboard.entityMenu.hpInc"></span>
        </li>
        <li>
            <kbd><span>←</span></kbd> <span ghs-label="tools.keyboard.entityMenu.hpDec"></span>
        </li>
        <li>
            <kbd><span>0</span></kbd>-<kbd><span>9</span></kbd>&nbsp;<span
                ghs-label="tools.keyboard.entityMenu.toggleCondition"></span>
        </li>
        <li>
            <kbd><span>x</span></kbd> <span ghs-label="tools.keyboard.entityMenu.xpInc"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.shift"></span></kbd>&nbsp;+&nbsp;<kbd><span>X</span></kbd>
            <span ghs-label="tools.keyboard.entityMenu.xpDec"></span>
        </li>
        <li>
            <kbd><span>l</span></kbd> <span ghs-label="tools.keyboard.entityMenu.lootInc"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.shift"></span></kbd>&nbsp;+&nbsp;<kbd><span>L</span></kbd>
            <span ghs-label="tools.keyboard.entityMenu.lootDec"></span>
        </li>
        <li>
            <kbd><span>b</span></kbd> <span ghs-label="tools.keyboard.entityMenu.blessInc"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.shift"></span></kbd>&nbsp;+&nbsp;<kbd><span>B</span></kbd>
            <span ghs-label="tools.keyboard.entityMenu.blessDec"></span>
        </li>
        <li>
            <kbd><span>c</span></kbd> <span ghs-label="tools.keyboard.entityMenu.curseInc"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.shift"></span></kbd>&nbsp;+&nbsp;<kbd><span>C</span></kbd>
            <span ghs-label="tools.keyboard.entityMenu.curseDec"></span>
        </li>
        <li>
            <kbd><span>k</span></kbd>&nbsp;|&nbsp;<kbd><span>d</span></kbd> <span
                ghs-label="tools.keyboard.entityMenu.kill"></span>
        </li>
        <li>
            <kbd><span>↑</span></kbd> <span ghs-label="tools.keyboard.entityMenu.maxHpInc"></span>
        </li>
        <li>
            <kbd><span>↓</span></kbd> <span ghs-label="tools.keyboard.entityMenu.maxHpDec"></span>
        </li>
        <li>
            <kbd><span>s</span></kbd> <span ghs-label="tools.keyboard.entityMenu.characterSheet"></span>
        </li>
        <li>
            <kbd><span>a</span></kbd> <span ghs-label="tools.keyboard.entityMenu.toggleAbsent"></span>
        </li>
    </ul>

    <p ghs-label="tools.keyboard.mainMenu.open"></p>
    <ul>
        <li>
            <kbd><span ghs-label="tools.keyboard.enter"></span></kbd>&nbsp;|&nbsp;<kbd><span
                    ghs-label="tools.keyboard.space"></span></kbd> <span
                ghs-label="tools.keyboard.mainMenu.confirm"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.esc"></span></kbd> <span
                ghs-label="tools.keyboard.mainMenu.decline"></span>
        </li>
        <li>
            <kbd><span ghs-label="tools.keyboard.tab">↹</span></kbd> <span
                ghs-label="tools.keyboard.mainMenu.select"></span>
        </li>
    </ul>
</div>